<template>
    <div class="message-item__action"
        :class="{
            [`message-item__action--${placement}`]: true
        }" v-click-outside="clickOutSideConfig">
        <div class="action__list">
            <template v-for="item in actions">
                <div v-if="item === ACTION.COPY"
                    class="action__item action__copy"
                    @click="copy"
                    :key="item">
                    <i class="action__icon icon_copy"></i>
                    <p class="action__name">复制</p>
                </div>
                <div v-else-if="item === ACTION.WITHDREW"
                    class="action__item action__withdrew"
                    @click="withdrew"
                    :key="item">
                    <i class="action__icon icon_recall"></i>
                    <p class="action__name">撤回</p>
                </div>
                <div v-else-if="item === ACTION.RETRY"
                    class="action__item action__retry"
                    @click="retry"
                    :key="item">
                    <i class="action__icon icon_resend"></i>
                    <p class="action__name">重发</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { resendMessage } from '@/utils/message_send'

    // 复制、撤回、重发
    const ACTION = {
        COPY: 'copy',
        WITHDREW: 'withdrew',
        RETRY: 'retry'
    }
    const PLACEMENT = ['top', 'bottom']

    export default {
        name: 'MessageAction',
        props: {
            isShow: {
                type: Boolean,
                required: true,
                default: false
            },
            name: {
                type: String,
                required: true
            },
            messageId: {
                type: String,
                required: true
            },
            copyContent: {
                type: String,
                required: false,
                validator (value) {
                    return value.trim() !== ''
                }
            },
            retryContent: {
                type: String,
                required: false,
                validator (value) {
                    return value.trim() !== ''
                }
            },
            actions: {
                type: Array,
                required: true,
                validator (value) {
                    const ACTION_LIST = Object.values(ACTION)
                    return value.every(item => ACTION_LIST.includes(item))
                }
            },
            placement: {
                type: String,
                required: true,
                default: 'top',
                validator (value) {
                    return PLACEMENT.includes(value)
                }
            }
        },
        data () {
            return {
                ACTION,
                clickOutSideConfig: {
                    handler: this.close,
                    events: ['touchstart']
                }
            }
        },
        methods: {
            async copy () {
                try {
                    await this.$copyText(
                        transformEmoji(this.copyContent)
                    )
                    this.close()
                    this.$toast('复制成功')
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                    this.$toast('复制失败')
                }

                function transformEmoji (text) {
                    return text.replace(/<img[^<]+title="([^"]+)"[^>]*>/gi, '$1')
                }
            },
            withdrew () {
                // to do: withdrew
            },
            retry () {
                resendMessage({
                    type: 'base',
                    detailType: this.name,
                    content: this.retryContent,
                    messageId: this.messageId
                })
                this.close()
            },
            close () {
                this.$emit('update:isShow', false)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .message-item {
        &__action {
            position: absolute;
            left: 50%;
            color: #fff;
            background-color: rgba(0, 0, 0, .8);
            border-radius: 4px;
            transform: translateX(-50%);
            z-index: 3;

            &::after {
                content: '\20';
                position: absolute;
                left: 50%;
                margin-left: -6px;
                width: 0;
                height: 0;
                border: 6px solid transparent;
                pointer-events: none;
            }

            &--top {
                bottom: calc(100% + 6px);

                &::after {
                    top: 100%;
                    border-top-color: rgba(0, 0, 0, .8);
                }
            }

            &--bottom {
                top: calc(100% + 6px);

                &::after {
                    bottom: calc(100%);
                    border-bottom-color: rgba(0, 0, 0, .8);
                }
            }
        }
    }

    .action {
        &__list {
            display: flex;
            align-items: stretch;
            justify-content: center;
            padding: 0 8px;
            text-align: center;
            height: 67px;
        }

        &__item {
            display: inline-flex;
            flex-direction: column;
            justify-content: center;
            width: 54px;
            cursor: pointer;
        }

        &__icon {
            display: block;
            width: 20px;
            height: 20px;
            font-size: 20px;
            margin: 0 auto 5px;
            background: 50% 50% no-repeat;
            background-size: cover;
        }

        &__name {
            line-height: 1;
            font-size: 14px;
        }
    }

    .is-desktop {
        .message-item--user {
            .message-item__action {
                left: 10px;
                transform: translateX(-50%);

                &::after {
                    margin-left: -25px;
                }

                &--top {
                    bottom: 20px;
                }
            }
        }

        .message-item--service {
            .message-item__action {
                left: auto;
                right: 10px;
                transform: translateX(50%);

                &::after {
                    margin-left: 14px;
                }

                &--top {
                    bottom: 20px;
                }
            }
        }
    }
</style>
